import { colorUseCases, css, getColorScaleValueByUseCase } from "@vitality-ds/system";
var backgrounds = colorUseCases.backgrounds;
export default css({
  backgroundColor: getColorScaleValueByUseCase("neutral", backgrounds.app),
  width: "100%",
  position: "relative"
});